import { LabelElement, OwnPropsOfRenderer } from '@jsonforms/core';
import { Hidden } from '@components/uploadForm/renderers/views/Hidden';
import { Typography } from 'antd';
const { Title } = Typography;

export const LabelRenderer = ({ uischema, visible }: OwnPropsOfRenderer) => {
  const labelElement: LabelElement = uischema as LabelElement;
  return (
    <Hidden hidden={!visible}>
      <Title level={4}>{labelElement?.text}</Title>
    </Hidden>
  );
};
